/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2021
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import menuVerticalIcon from '../../../../assets/images/Fireboard/action_buttons/menu-vertical.png';
import classes from './CheckCard.module.css';
import FireboardUtils from '../../../../util/fireboard-util';
import useElapsedTime from '../../../../hooks/useElapsedTime';
import modeEnums from '../../../../enums/modeEnums';

const CheckCard = props => {
  const { check, onSelectCheck, isCheckSelected, checkConfig, deviceGroup, currentMode } = props;
  const { data: checkData, buttons: actionButtons } = checkConfig || {};
  const { onHandleCheckActions, closeDate } = check || {};
  const { elapsedTimeInHrMinSec, elapsedTimeInMillisecond } = useElapsedTime(closeDate);
  let color = 'white';

  if (currentMode === modeEnums.TABLE_DELIVERY && deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
    const { tableDeliveryWarningTime, tableDeliveryErrorTime } = deviceGroup || {}; //error & warning are in seconds
    const elapsedTimeInSeconds = elapsedTimeInMillisecond / 1000;
    if (
      tableDeliveryErrorTime &&
      tableDeliveryErrorTime !== 0 &&
      elapsedTimeInSeconds > tableDeliveryErrorTime
    ) {
      color = 'red';
    } else if (
      tableDeliveryWarningTime &&
      tableDeliveryWarningTime !== 0 &&
      elapsedTimeInSeconds > tableDeliveryWarningTime
    ) {
      color = 'orange';
    }
  }

  const onSelectCheckHandler = () => {
    onSelectCheck && onSelectCheck(check);
  };

  return (
    <div
      className={classes.checkCardContainer}
      style={{
        backgroundColor: isCheckSelected ? 'lightgray' : '#ffffff',
        border: `0.5vh solid ${color}`
      }}
      onClick={onSelectCheckHandler}
    >
      <div className={classes.menuIconWrapper} onClick={onHandleCheckActions}>
        <img src={menuVerticalIcon} className={classes.menuIcon} />
      </div>
      <div className={classes.contentWrapper}>
        {checkData.map(data => (
          <div key={data.value} className={classes.dataText}>{data.value}</div>
        ))}
        {currentMode === modeEnums.TABLE_DELIVERY && (
          <div className={classes.timeText}>Time: {elapsedTimeInHrMinSec}</div>
        )}
      </div>
      <div className={classes.buttonWrapper}>
        {actionButtons.map(button =>
          <Button
            key={button.key}
            className={classes.button}
            onClick={button.onClick}>
            {button.name}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CheckCard;

CheckCard.propTypes = {
  check: PropTypes.object.isRequired,
  isCheckSelected: PropTypes.bool,
  onSelectCheck: PropTypes.func,
  checkConfig: PropTypes.object,
  deviceGroup: PropTypes.object,
  currentMode: PropTypes.string,
};

CheckCard.defaultProps = {
  check: {},
  isCheckSelected: false,
  onSelectCheck: () => { },
  checkConfig: {},
  deviceGroup: null,
  currentMode: modeEnums.TABLE_DELIVERY,
};
